import { createContext, useEffect, useState } from "react";
import { ILearningContextProps } from "../types/interfaces/ILearningContextProps";
import { ILearningProviderProps } from "../types/interfaces/ILearningProviderProps";
import { useErrorContext } from "../../global/hooks/useErrorContext";
import { ILearningList } from "../types/interfaces/ILearningList";
import { useAuthenticationContext } from "../../global/hooks/useAuthenticationContext";

//The learning context object holds the latest value of the state.
export const LearningContext = createContext<ILearningContextProps | undefined>(undefined);

//This component is responsible to share the ilp data between components.
export const LearningProvider: React.FC<ILearningProviderProps> = ({ children }) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [learningList, setLearningList] = useState<ILearningList | null>({ List : null });
    const { cstKey } = useAuthenticationContext();
    const { setError } = useErrorContext();

    const API_GET_LEARNING = process.env.REACT_APP_API_GET_LEARNING;
    const INELIGIBLE_ERROR_TEXT: string | null = process.env.REACT_APP_LEARNING_INELIGIBLE_ERROR_TEXT ?? null;

    const handleError = (message: string | null, statusCode: number) => {  
        setError({ message, statusCode });
        setIsLoading(false);
    };

    //Function to fetch data using the get aap learning api endpoint.
    const LearningFetch = async () => {
        try {
            const apiGetLearning = `${API_GET_LEARNING}${cstKey}`;
            const response = await fetch(apiGetLearning);
            if (!response.ok) {
                console.log('get', response.statusText);
                if (response.status === 401 || response.status === 403) {
                    return handleError(INELIGIBLE_ERROR_TEXT, response.status);
                } else {
                    return handleError(null, 1);
                }
            }
            const result = await response.json();
            if (!result) {
                return handleError(null, 2);
            } else {
                if (result.CustomerKey === null || result.Data === null || (!result.Succeeded && result.Errors !== null)) {
                    return handleError(null, 3);
                }
                setLearningList(result.Data);
                setIsLoading(false);
            }
        } catch (error: any) {
            console.log('get error', error);
            handleError(null, error.status);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (cstKey !== null && cstKey !== undefined) {
            LearningFetch();
        }
    }, [cstKey]);
    
    const value = {
        learningList,
        isLoading
    };

    return (
        <LearningContext.Provider value={value}>
            {children}
        </LearningContext.Provider>
    );
};